<template>
    <div>
        <div class="page-title">Bath edit to change status</div>
        <div class="page-box">
            <div class="search-box">
                <el-form label-width="180px" :model="formLabelAlign">
                    <el-form-item label="Status change to ">
                        <el-select v-model="formLabelAlign.status" @change="change(formLabelAlign.status)" placeholder="Please select ">
                            <el-option
                            v-for="item in applicationStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <el-table
            :data="workOrders"
             v-loading="loading"
             :key="key"
            style="width: 100%;">
                <el-table-column
                    prop="registrationNo"
                    label="Registration"
                    >
                </el-table-column>
                <el-table-column
                    label="Applicant"
                    >
                    <template slot-scope="{row}">
                        <span v-if="row.applicantName">{{JSON.parse(row.applicantName).en || ''}} {{JSON.parse(row.applicantName).zh_tc || ''}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    
                    label="Old Status">
                    <template slot-scope="{row}">
                        <span>{{row.status | applicationStatus}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="newStatus"
                    label="New Status">
                    <template slot-scope="{row}">
                        <span>{{row.newStatus | applicationStatus}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="checkbox-page">
                <el-radio-group v-model="checkList">
                    <el-radio name="type" v-for="(item,index) in sendType" :key="index" :label="item.value">{{item.label}}</el-radio>
                </el-radio-group>
                <el-button  type="warning" @click="onSend">Send</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {getApplicationDetail,addBatchChangeApplicationFormsStatus} from '@/api/admin/application'
    export default {
        props:{
          formType:{
            type:Number,
            default:0
          }
        },
        data() {
            return {
                key:'',
                loading:false,
                ff:[],
                workOrders:[],
                checkList:'',
                formLabelAlign: {
                    status: '',
                }
            }
        },
        created(){
            this.initialize()
        },
        methods:{
            change(k){
                 this.workOrders.map((v)=>{
                    v.newStatus = k
                })
                this.key = Math.random()
                this.$forceUpdate()
            },
            onSend(){
                this.addBatchChangeApplicationFormsStatus()
            },
            addBatchChangeApplicationFormsStatus(){
                let from =  {
                        applicationFormIds:JSON.parse(this.$route.params.applicationFormIds), 
                        newStatus: this.formLabelAlign.status, 
                        sendType: this.checkList || 0,
                        formType:this.formType
                }
                addBatchChangeApplicationFormsStatus(from).then(()=>{
                   this.$message.success('Save success')
                   this.$router.push({path:`/admin/application/${this.formType}`})
                })
            },
            initialize(){
                const that = this
                const promises = JSON.parse(this.$route.params.applicationFormIds).map((element) => {
                    return this.getApplicationDetail(Array.of(element))
                })
                Promise.all(promises)
                    .then(function(posts) {
                       that.workOrders = posts.flat(Infinity)
                    })
                    .finally(() => {
                      this.loading = false
                    })
            },
            getApplicationDetail(id){
              this.loading = true
              return getApplicationDetail(id).then((v)=>{
                    return v.data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    background-color: #fff;
    padding-bottom: 30px;
}
.page-box-title{
    display: flex;
    border-bottom: 1px solid #707070;
    justify-content: space-between;
    padding: 0 47px;
    padding-top:46px;
    padding-bottom: 27px;
}
.search-box{
    padding-top: 50px;
    padding-bottom: 40px;
    padding-left: 50px;
    padding-right: 50px;
}
.checkbox-page{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 30px;
    margin-top: 30px;
}
.el-button--warning{
    margin-left: 30px;
}
</style>